<!--
 * @Author: hfxie
 * @Date: 2021-01-01 14:52:54
 * @LastEditors: hfxie
 * @LastEditTime: 2022-06-07 14:33:22
 * @Description: 甘特图右侧下方区横道连线操作时指示线
-->

<template>
  <div class="guideline-box">
    <div
        class="guide-dash"
        v-show="$store.state.moveLinkFlag"
        :style="
          `top:${$store.state.dashPosTop}px;
          left:${$store.state.dashPosLeft}px;
          height: ${$store.state.dashHeight}px;
          transform: rotate(${$store.state.dashDeg}deg);
          border-color:blue`"
      ></div>
  </div>
</template>

<script>
export default {
  name: "GuideLine",
  data() {
    return {
      count: 0,
    };
  },
};
</script>

<style scoped lang='less'>
  .guideline-box{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 300;
    .guide-dash{
      position: absolute;
      top: 10px;
      left: 0;
      height: 0px;
      box-sizing: border-box;
      width: 1px;
      border-right: 1px dashed red;
      position: absolute;
      transform-origin: top center;
    }
  }
</style>
